import { lazy } from 'react';


export default [
  { path: '/login', element: lazy(() => import('containers/pages/Login')), external: true },
  { path: '/reset-password', element: lazy(() => import('containers/pages/ResetPassword')), external: true },
  { path: '/settings', element: lazy(() => import('containers/pages/Settings/Settings')), external: false },
  { path: '/catalog', element: lazy(() => import('containers/pages/Catalog')), external: false },
  { path: '/preview', element: lazy(() => import('containers/pages/Preview/Preview')), external: false },
  { path: '/profile', element: lazy(() => import('containers/pages/Profile/Profile')), external: false },
  { path: '/countries', element: lazy(() => import('containers/pages/Countries/Countries')), external: false },
  { path: '/map?/*', element: lazy(() => import('containers/pages/Main')), external: false },
];
